import Types from './Types';

export const getActiveAnnouncementsRequest = (body) => ({
    type: Types.GET_ACTIVE_ANNOUNCEMENTS_REQUEST,
    payload: body
});

export const getActiveAnnouncementsSuccess = (data) => ({
    type: Types.GET_ACTIVE_ANNOUNCEMENTS_SUCCESS,
    payload: data
});

export const getActiveAnnouncementsFail = () => ({
    type: Types.GET_ACTIVE_ANNOUNCEMENTS_FAIL
});

//LOADING
export const addAnnouncementsLoading = (isLoading) => ({
    type: Types.ADD_ANNOUNCEMENTS_LOADING,
    payload: isLoading
});

